<template>
    <div>
        <el-row :gutter="10">
            <el-col :span="7">
                <el-date-picker size="mini"
                v-model="queryParam.dateRange"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions">
                </el-date-picker>
            </el-col>
            <el-col :span="3">
                <el-input v-model="queryParam.userName" size="mini" clearable placeholder="商务人"></el-input>
            </el-col>
            <el-col :span="9">
                <el-button type="primary" size="mini" @click="getTraceHistoryList"><i class="el-icon-search"></i>&nbsp;查询</el-button>
                <el-button type="warning" size="mini" @click="reset"><i class="el-icon-refresh"></i>&nbsp;重置</el-button>
            </el-col>
            <el-col :span="5">
                <el-tag type="warning" size="mini">{{ '共跟进'+total+'次；项目'+traceProNum+'个' }}</el-tag>
            </el-col>
        </el-row>
        <el-divider><i class="el-icon-search"></i></el-divider>
        <el-table :data="traceLogList" ref="TraceTable" size="mini" border  height="610" style="width: 100%" v-loading="traceLoading" @sort-change="SortChange" 
            element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.8)" >
            <el-table-column type="index" width="70" label="序号" show-overflow-tooltip ></el-table-column>
            <el-table-column label="跟进人" width="120" prop="xmname" show-overflow-tooltip :sortable="'custom'" ></el-table-column>
            <el-table-column label="跟进日期" width="140" prop="traceDate" show-overflow-tooltip :sortable="'custom'">
                <template slot-scope="scope">
                    <el-tag size="mini" type="info">{{ scope.row.traceDate|dateformatAll('YYYY-MM-DD') }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="次序" prop="traceTimes" width="80"></el-table-column>
            <el-table-column label="跟进项目编号" width="180" prop="panum" show-overflow-tooltip :sortable="'custom'"></el-table-column>
            <el-table-column label="跟进项目名" width="300" prop="paname" show-overflow-tooltip ></el-table-column>
            <el-table-column label="项目类型" width="100" prop="type" :sortable="'custom'" >
                <template slot-scope="scope">
                    <el-popover placement="top" effect="light" :content="scope.row.detail"  trigger="hover">
                        <div slot="reference">
                            <el-tag size="mini" type="primary" v-if="scope.row.type==0">跟踪项目</el-tag>
                            <el-tag size="mini" type="success" v-else>正式项目</el-tag>
                        </div>
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column label="跟进方式" width="100" prop="traceType" show-overflow-tooltip ></el-table-column>
            <el-table-column label="商务状态" width="160" prop="traceStatusName" :sortable="'custom'" >
                <template slot-scope="scope">
                    <i :class="scope.row.emojiChar"></i>&nbsp;{{ scope.row.traceStatusName }}
                </template>
            </el-table-column>
        </el-table>
        <!--分页部分-->
        <el-pagination background @size-change="pagesizeChange"
                        @current-change="pagenumChange"
                        :current-page="queryParam.pageNum"
                        :page-sizes="[10,50, 100,200,500]"
                        :page-size="queryParam.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total" style="margin-top:10px;">
        </el-pagination>
    </div>
</template>
<script>
export default {
    name:"TraceHistory",
    props:{
        
    },
    data(){
        return {
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit('pick', [start, end]);
                    }
                }]
            },
            queryParam:{
                dateRange:[],
                userName:"",
                order:0,
                pageSize:50,
                pageNum:1
            },
            traceLogList:[],
            total:0,
            traceLoading:false,
            traceProNum:0,
        }
    },
    mounted(){
        this.initDateRange()
        this.getTraceHistoryList()
    },
    methods:{
        initDateRange(){
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            const range=[start,end]
            this.queryParam.dateRange=range
        },
        async getTraceHistoryList(){
            this.traceLoading=true
            const{data:res}=await this.$http.post('os/traceHistory',this.queryParam).catch(err => err)
            if(res){
                this.traceLogList=res.traceList
                this.total=res.total
                this.traceProNum=res.traceProNum
            }
            this.traceLoading=false
        },
        reset(){
            this.queryParam={
                dateRange:[],
                userName:"",
                order:0,
                pageSize:50,
                pageNum:1
            }
            this.initDateRange()
            this.$refs.TraceTable.columns.forEach(element => {
                element.order=''
            });
            this.getTraceHistoryList()
        },
        SortChange(column){
            if (column.prop == "traceDate") {
                if (column.order == "ascending" || column.order == null) {
                this.queryParam.order = 1;
                } else {
                this.queryParam.order = 0;
            }
            }else if(column.prop=="traceStatusName"){
            if (column.order == "ascending" || column.order == null) {
                this.queryParam.order = 3;
                } else {
                this.queryParam.order = 2;
            }
            }else if(column.prop=="xmname"){
            if (column.order == "ascending" || column.order == null) {
                this.queryParam.order = 5;
                } else {
                this.queryParam.order = 4;
            }
            }else if(column.prop=="panum"){
            if (column.order == "ascending" || column.order == null) {
                this.queryParam.order = 7;
                } else {
                this.queryParam.order = 6;
            }
            }else if(column.prop=="type"){
            if (column.order == "ascending" || column.order == null) {
                this.queryParam.order = 9;
                } else {
                this.queryParam.order = 8;
            }
            }
            else{
            this.queryParam.order = 0;
            }
            this.getTraceHistoryList()
        },
        pagesizeChange(newSize){
            this.queryParam.pageSize=newSize
            this.queryParam.pageNum=1
            this.getTraceHistoryList()
        },
        pagenumChange(newNum){
            this.queryParam.pageNum=newNum
            this.getTraceHistoryList()
        }
    },
}
</script>
<style scoped>
</style>